export default __webpack_public_path__ + "static/media/female.f908b911.png";